'use client';

import { type ReactNode, useEffect } from 'react';
import { useMsalAccountUsername } from '../../contexts/TokenContext/useMsalAccount';
import { useSetAuthenticatedUserContext } from './AppInsightsWrapper';

export function AppInsightsUserLogger(): ReactNode {
	const setUserContext = useSetAuthenticatedUserContext();
	const username = useMsalAccountUsername();

	useEffect(() => {
		// Setter isn't ready
		if (!setUserContext) {
			return;
		}

		// No user available
		if (!username) {
			return;
		}
		setUserContext(username);
	}, [setUserContext, username]);

	return null;
}
